export default {
	create_document: 'Document',
	create_menu_appointment: 'Appointment',
	create_menu_dataset: 'Dataset',
	create_menu_document: 'Document',
	create_menu_mail: 'Mail',
	create_menu_message: 'Message',
	create_menu_note: 'Note',
	create_menu_phonecall: 'Phone call',
	create_menu_task: 'Task',
	menu_addon_not_available: 'This add-on is no longer available',
	menu_addons: 'Add-ons',
	menu_all: 'All',
	menu_appointments: 'Appointments',
	menu_create: 'New',
	menu_datasets: 'Datasets',
	menu_datasets_box_label: 'Instances',
	menu_date: 'Date',
	menu_documents: 'Documents',
	menu_documents_box_label: 'Shelves',
	menu_favorites: 'Shortcuts',
	menu_filter: 'Filter',
	menu_folder_explorer: 'Organization',
	menu_folder_explorer_actions: 'Actions',
	menu_folder_explorer_add_folder: 'Create folder',
	menu_folder_explorer_add_list_container: 'Create list folder',
	menu_folder_explorer_back_to_organization: 'Back to organization',
	menu_folder_explorer_close: 'Close',
	menu_folder_explorer_confirm_delete_message: 'Do you really want to delete this item?',
	menu_folder_explorer_confirm_delete_title: 'Delete item',
	menu_folder_explorer_create_and_link_ido: 'Create record from folder',
	menu_folder_explorer_empty_folders: 'No folders available',
	menu_folder_explorer_empty_ido_favorites: 'No record favorites available',
	menu_folder_explorer_empty_lists: 'No lists available',
	menu_folder_explorer_filter_placeholder: 'Filter',
	menu_folder_explorer_folders_tab: 'Folders',
	menu_folder_explorer_ido_favorites_searching: 'Searching records…',
	menu_folder_explorer_ido_favorites_tab: ' Favorites',
	menu_folder_explorer_legacy_badge: 'Legacy',
	menu_folder_explorer_lists_tab: 'Lists',
	menu_folder_explorer_load_error: 'The folder explorer could not be loaded.',
	menu_folder_explorer_loading: 'Loading tree…',
	menu_folder_explorer_notebook_list_empty: 'This folder contains no entries',
	menu_folder_explorer_notebook_list_title: 'Folder contents',
	menu_folder_explorer_open: 'Open',
	menu_folder_explorer_open_as_kanban_board: 'Open as Kanban board',
	menu_folder_explorer_open_not_supported: 'This legacy target is not mapped in the app yet',
	menu_folder_explorer_remove: 'Delete',
	menu_folder_explorer_rename: 'Rename',
	menu_folder_explorer_rename_prompt: 'Name',
	menu_folder_explorer_search_empty: 'No matching entries found',
	menu_folder_explorer_search_placeholder: 'Search',
	menu_folder_explorer_share: 'Share',
	menu_folder_explorer_unshare: 'Revoke',
	menu_global_filter: 'Global filter',
	menu_ido_favorites_context_menu_create_ido_linked_task: 'Create task',
	menu_ido_favorites_remove_from_favorites: 'Remove from favorites',
	menu_ido_search_empty_title: 'Search across all records',
	menu_ido_search_no_results: 'No results',
	menu_idos: 'Records',
	menu_idos_all: 'Show all records',
	menu_idos_as_list: 'Show record instances as list',
	menu_idos_box_label: 'Record instances',
	menu_inbox: 'Home',
	menu_kanban: 'Kanban Board',
	menu_kanban_shared_query_not_found: 'This list could not be opened as a Kanban board.',
	menu_lists: 'Lists',
	menu_logout: 'Logout',
	menu_logout_dialog_message: 'Do you really want to log out?',
	menu_logout_dialog_title: 'End session',
	menu_mails: 'Mails',
	menu_mails_box_label: 'Mailboxes',
	menu_messages: 'Messages',
	menu_mine: 'Mine',
	menu_notes: 'Notes',
	menu_open: 'Open',
	menu_phonecalls: 'Calls',
	menu_phonecalls_box_label: 'Calllists',
	menu_search_clear: 'Clear search',
	menu_search_no_results: 'No results',
	menu_search_placeholder: 'Search menu…',
	menu_settings: 'Settings',
	menu_sidebar_search_placeholder: 'Search...',
	menu_sidebar_tab_menu: 'Menu',
	menu_sidebar_tab_organization: 'Organization',
	menu_sidebar_tab_search: 'Search',
	menu_sidebar_tab_users: 'Users',
	menu_tasks: 'Tasks',
	menu_timer: 'Timer',
	menu_today: 'Today',
	menu_trash: 'Trash',
	menu_user_online: 'User',
	menu_user_online_no_users_offline: 'No users offline',
	menu_user_online_no_users_online: 'No users online',
	menu_user_online_offline_users: 'Offline',
	menu_user_online_offline_users_short: 'offline',
	menu_user_online_online_users: 'Online',
	menu_user_online_online_users_short: 'online',
};
